import type { AnchorEntitlements } from "@/lib/entitlements/anchorsClient";

/** Client mirror of server `assertTurboSignEntitlementActive` (TS-10). */
export function turboSignEntitlementEnabled(anchors: AnchorEntitlements | null | undefined): boolean {
  if (!anchors) return true;
  return anchors.turbo_sign;
}
